import store from '@/store';
import { leaseType } from '@/util/dictList.js'
export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: false,
  menu: true,
  indexLabel: '序号',
  selection: true,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  column: [
    {
      label: '进件编号',
      prop: 'businessCode',
      type: 'input',
      display: false,
      searchOrder: 996,
      search: true,
      hide:false
    },
    {
      label: '租赁人',
      prop: 'name',
      type: 'input',
      search: true,
      searchOrder: 999,
      searchPlaceholder: '请输入租赁人',
      display: false,
    },
    {
      label: '车牌号',
      prop: 'carFirstNumber',
      span: 24,
      search: true,
      type: 'input',
      searchOrder: 998,
      display: false,
    },
    {
      label: '产品类型',
      prop: 'rentType',
      display: false,
      search: true,
      type: 'select',
      hide:true,
      searchOrder: 1000,
      dicData: store.getters.porductTypes,
    },
    {
      label: '产品类型',
      prop: 'rentTypeName',
      display: false,
    },
    {
      label: '租期',
      prop: 'tenancy',
      type: 'select',
      display: false,
      search: false,
      showColumn: false,
      dicData: leaseType,
    },
    {
      label: '租率',
      prop: 'lendingRate',
      type: 'select',
      display: false,
      search: false,
      showColumn: false,
      dicData: [],
      hide:true,
      props: {
        label: "lable",
        value: "rate",
      },
    },
    {
      label: '租率',
      prop: 'lendingRateString',
      display: false,
      search:false,
    },
    {
      label: '所属代理商',
      prop: 'businessDeptId',
      type: 'select',
      filterable: true,
      // multiple: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: false,
      searchClearable: true,
      defaultExpandAll: true,
      hide: true,
      dicData: [],
      props: {
        label: 'title',
        value: 'id',
      },
    },
    {
      label: 'id',
      prop: 'id',
      display: false,
      hide: true,
    },
    {
      label: '租付类型',
      prop: 'loanBeforePayName',
      display: false,
    },
    {
      label: '租赁金额',
      prop: 'lendingAmount',
      type: 'select',
      search: false,
      display: true,
    },
    {
      label: '每期租金',
      prop: 'lendingAmountPer',
      type: 'select',
      search: false,
      display: true,
    },
    {
      label: '已结清期数',
      minWidth:90,
      prop: 'currentTenancy',
      type: 'select',
      search: false,
      display: true,
    },
    {
      label: '返佣比例',
      prop: 'rakeBackRate',
      type: 'select',
      search: false,
      display: true,
    },
    {
      label: '返佣金额',
      prop: 'rakeBackMoney',
      type: 'select',
      search: false,
      display: true,
      hide:true
    },
    {
      label: '所属代理商',
      minWidth:90,
      prop: 'deptName',
      span: 24,
      display: false,
    },
    {
      label: '是否省代',
      prop: 'provincialRepresentativeName',
      display: true,
      search: false,
      type: 'select',
      hide:false,
      // dicData: [
      //   {
      //     label: '否',
      //     value: 0,
      //   },
      //   {
      //     label: '是',
      //     value: 1,
      //   },
      // ],
    },
    {
      label: '代理商类型',
      prop: 'agentTypeName',
      minWidth:90,
      span: 24,
      display: false,
    },
    {
      label: '申请人',
      prop: 'applyUserName',
      minWidth:90,
      span: 24,
      display: false,
      hide:true
    },
    {
      label: '申请时间',
      prop: 'applyTime',
      type: 'daterange',
      search: false,
      searchRange: true,
      minWidth:90,
      span: 24,
      display: false,
      hide:true,
      valueFormat: 'yyyy-MM-dd',
      searchOrder: 997,
    },
  ],
};
